import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { connect } from 'react-redux';
import {
	postRequest,
	getRequest,
	setCurrentUser,
	showHideLoader,
	showHideModal,
	initSignalRConnectionAndHandlers,
} from '../../Redux/Actions/SharedActions';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Toast from '../Shared/Toasts/Toast';
import showPass from '../../Assets/showPass.png';
import dontShowPass from '../../Assets/dontShowPass.png';
import { Input } from '../Shared/small_components';
import { SmallLoader } from '../../Loader/defaultAppLoader';
import lookupIc from "../../Assets/lookup.png";
import success from '../../Assets/check.svg';
import OTPScreen from './OTPScreen';
import footer_Banner from '../../Assets/TBS_EXHIBITING.png';
import OTPScreenNew from './OTPScreenNew';
const ReCaptcha = ({ loginUser }) => {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const clickHandler = async () => {
		const token = await executeRecaptcha('login_page');
		loginUser(token);
	};

	return (
		<div className="btn-main" onClick={() => clickHandler()}>
			<span>LOGIN</span>
		</div>
	);
};
const ForgotPassword = ({ dispatch, error400 }) => {
	const [state, setState] = useState({
		email: '',
		emailErr: '',
		success: false,
		type: '',
		loader: false,
		tryAgainStep: false,
		loanStep: false,
		guarantorStep: false,
		guarantorEmails: [],
		selectedEmail: '',
		clickHere: false,
		companyLookupName: '',
		showList: false,
		companyList: {},
		loanID: '',
		companyReg: '',
		regNo: '',
		loanMatch: false,
	});

	const onChange = (e) => {

		setState({ ...state, email: e.target.value, emailErr: '' });

	};

	const checkEmail = () => {
		if (state.email === '') {
			setState({ ...state, emailErr: 'Required' });
		} 
		if (!/[\w-.]+@([\w-]+.)+[\w-]{2,4}/.test(state.email)) {
				setState({ ...state, emailErr: 'Invalid Email' });
			} 
			else {
			dispatch(
				postRequest(
					'/api/Customer/EmailCheck',
					{
						email: state.email,
						lenderId:1
					},
					(val) => {
						setState((prevState) => ({ ...prevState, loader: val }));
					},
					sucessFunctionEmail,
					(err) => {
						error400(err);
					}
				)
			);
		}
	};

	const sucessFunctionEmail = (res) => {
		if (res.data.message === 'Email not found') setState((prevState) => ({ ...prevState, tryAgainStep: true }));
		if (res.data.message === 'Registration email has been sent')
			setState((prevState) => ({ ...prevState, success: true, tryAgainStep: false, type: 'registration' }));
		if (res.data.message === 'Recovery email has been sent')
			setState((prevState) => ({ ...prevState, tryAgainStep: false, success: true, type: 'recovery' }));
	};

	const lookupCompany = () => {

		dispatch(
			postRequest(
				'/api/Customer/CompanyLookup',
				{ CompanyID: null, Name: state.companyLookupName,lenderId:1 },
				(val) => {
					setState((prevState) => ({ ...prevState, loader: val }));
				},
				(res) => {
					setState((prevState) => ({
						...prevState,
						companyList: res.data.companyInfoResponse,
						showList: true,
						loanStep: true,
					}));
				},
				(err) => {
					if (err.response && err.response.data.errors && err.response.data.errors.length > 0) {
						if (typeof err.response.data.errors[0] === 'object') {
							Toast.error(err.response.data.errors[0].description, {}, 4);
						} else {
							Toast.error(err.response.data.errors);
						}
					} else if (err.response && !Array.isArray(err.response.data.errors) && err.response.data.errors) {
						Object.keys(err && err.response.data.errors).map((item, i) => {
							return Toast.error(
								err.response.data.errors[item].length && err > 0
									? err.response.data.errors[item]
									: err.response.data.errors[item],
								{},
								1
							);
						});
					} else if (err.response && err.response.data.message) {
						Toast.error(err.response.data.message, {}, 4);
					} else {
						Toast.error('Something went wrong. Please try again');
					}
				}
			)
		);
	};

	const getEmails = (reg) => {
		dispatch(
			getRequest(
				'/api/Customer/GuarantorEmails/Company/' + reg + '/1',
				'',
				(val) => {
					setState((prevState) => ({ ...prevState, loader: val }));
				},

				(res) => {
					setState((prevState) => ({
						...prevState,
						guarantorStep: true,
						loanStep: false,
						regNo:reg,
						guarantorEmails: res.data.emails ? res.data.emails : [],
					}));
				},
				(err) => {
					error400(err);
				}
			)
		);
	};

	const sendRegisterRequest = () => {
		dispatch(
			postRequest(
				'/api/Customer/Register/Request',
				{
					email: state.email,
					registrationNo: state.regNo,
					emailValue: state.selectedEmail,
					lenderId:1
				},
				(val) => {
					setState((prevState) => ({ ...prevState, loader: val }));
				},
				() => {
					setState((prevState) => ({ ...prevState, success: true, type: 'register', guarantorStep: false }));
				},
				(err) => {
					error400(err);
				}
			)
		);
	};

	if (state.tryAgainStep === true) {
		return (
			<>
				{state.loader === true ? (
					<div>
						<SmallLoader />
					</div>
				) : (
						<div className="form-group">
							<p style={{ marginTop: '-35px', fontWeight: '600' }}>
								Sorry, we do not recognise that email. Please try again or{' '}
								<span
									className="click-here"
									onClick={() =>
										setState((prevState) => ({ ...prevState, loanStep: true, tryAgainStep: false }))
									}
								>
									click here&nbsp;
							</span>
							if you do not know this email.
						</p>
							<Input
								// label="Please enter the email for your username, if you do not know the email, please email office@cubefunder.com."
								type="text"
								className="form-control"
								defaultValue={state.email}
								id={'recoveryEmail'}
								onChange={onChange}
								error={state.emailErr}
							/>
							<div style={{ textAlign: 'right' }}>
								<div
									className={`btn-main ${state.emailErr !== '' ? 'disabledDiv' : ''}`}
									onClick={state.emailErr !== '' ? () => { } : () => checkEmail()}
								>
									<span>Submit</span>
								</div>
							</div>
						</div>
					)}
			</>
		);
	}

	if (state.loanStep === true) {
		return (
			<>
				{state.loader === true ? (
					<div>
						<SmallLoader />
					</div>
				) : (
						<>
							<p style={{ textAlign: 'left', fontWeight: '600', marginTop: '-35px', marginBottom: '-15px' }}>
								Please Lookup your Company:
						</p>
							<div className="form-group">
								{/* <div className="company-lookup"> */}
								<Input
									label="Company Name"
									id="companyLookupName"
									defaultValue={state.companyLookupName}
									onChange={(e) => {
										let val = e.target.value;
										setState((prevState) => ({
											...prevState,
											companyLookupName: val,
										}));
									}}
									// inputClassName={"lookup"}
									lookup={true}
									autoComplete="off"
									autofill="false"
									// parentclassname={'positionRelative'}
									icon={lookupIc}
									// imageName={"mobileIconInput mobileIcon"}
									iconClassName={'company-lookup '}
									iconClick={() => {
										state.companyLookupName !== "" ? lookupCompany() : Toast.error("Please enter a company name")
									}}

								/>
								
							</div>


							{state.companyList.items && state.companyList.items.length > 0 && state.showList && (
								<div>
									<p style={{ textAlign: 'left', fontWeight: '600', marginBottom: '5px' }}>
										Please select your company:
								</p>
									<table className="ablock3" style={{ marginRight: '5px', width: '100%' }}>
										<tbody>
											{state.companyList.items.length > 0 ? (
												state.companyList.items.map((obj, i) => {
													return (

														<tr key={i}>
															<td className="hover-row" style={{ paddingBottom: '4px' }}
																onClick={(e) => {
																	getEmails(obj.company_number);
																}}
															>
																{obj.company_number}, {obj.title}
															</td>
														</tr>

													);
												})
											) : (
													<tr>
														<td>
															<p>No Company Found</p>
														</td>
													</tr>
												)}
										</tbody>
									</table>
								</div>
							)}

							<p style={{ textAlign: 'left' }}>
								If you do not know your company name, please email us at&nbsp;
							<span
									className="click-here"
									onClick={() =>
										window.open(
											'mailto:office@cubefunder.com?subject=Customer Portal Login Credentials Request'
										)
									}
								>
									office@cubefunder.com
							</span>
							&nbsp;or call us on{' '}
								<span className="click-here" onClick={() => window.open('tel:020 3137 2417')}>
									020 3137 2417.
							</span>
							</p>
						</>
					)}
			</>
		);
	}

	if (state.guarantorStep === true) {
		return (
			<>
				{state.loader === true ? (
					<div>
						<SmallLoader />
					</div>
				) : (
						<>
							<div className="form-group">
								{/* <ul> */}
								{state.guarantorEmails.length > 0 ? (
									<>
										<p
											style={{
												textAlign: 'left',
												fontWeight: '600',
												marginTop: '-35px',
												marginBottom: '15px',
											}}
										>
											Great, please select the email we can send a recovery link from the following:
									</p>
										{state.guarantorEmails.map((obj, i) => {
										
											return (
												<div key={i} className="row" style={{ marginTop: '6px', marginLeft: '4px' }}>
													<>
														{' '}
														<input
															type="radio"
															name="choice"
															id={i.value}
															value={i.value}
															onChange={(e) => {
																// let val = e.target.checked ? true : false;

																setState((prevState) => ({
																	...prevState,
																	selectedEmail: obj.value,
																	email: obj.text,
																}));
															}}
														/>{' '}
													&nbsp; {obj.text}
													</>
												</div>
											);
										})}
										<div style={{ textAlign: 'right' }}>
											<div
												className={`btn-main ${state.selectedEmail === '' ? 'disabledDiv' : ''}`}
												onClick={() => state.selectedEmail !== '' && sendRegisterRequest()}
											>
												<span>Submit</span>
											</div>
										</div>
									</>
								) : (
										<p style={{ textAlign: 'left', marginTop: '-35px' }}>
											Sorry we did not find any email for this company. Please contact us at&nbsp;
											<span
												className="click-here"
												onClick={() => window.open('mailto:office@cubefunder.com')}
											>
												office@cubefunder.com
									</span>
									&nbsp;or call us on{' '}
											<span className="click-here" onClick={() => window.open('tel:020 3137 2417')}>
												020 3137 2417
									</span>{' '}
									to update your details
										</p>
									)}
							</div>
							{state.guarantorEmails.length > 0 && (
								<p style={{ textAlign: 'left' }}>
									If the email is not in the list above, please contact us at&nbsp;
									<span
										className="click-here"
										onClick={() => window.open('mailto:office@cubefunder.com')}
									>
										office@cubefunder.com
								</span>
								&nbsp;or call us on{' '}
									<span className="click-here" onClick={() => window.open('tel:020 3137 2417')}>
										020 3137 2417
								</span>{' '}
								to update your details
								</p>
							)}
						</>
					)}
			</>
		);
	}

	if (state.success === true) {
		return (
			<div style={{ marginTop: '-1%' }}>
				<img src={success} alt="success" style={{ width: '8%', height: 'auto' }} />
				<p>
					Thank you, we have sent the login details to{' '}
					<span style={{ fontWeight: '600', cursor: 'auto' }}>{state.email}</span>
				</p>

			</div>
		);
	}

	return (
		<div>
			{state.loader === true ? (
				<div>
					<SmallLoader />
				</div>
			) : (
					<>
						<div className="form-group">
							<p style={{ marginTop: '-35px', fontWeight: '600' }}>
								Please enter the email associated with your Cubefunder loan:
						</p>
							<Input
								
								type="text"
								className="form-control"
								defaultValue={state.email}
								id={'recoveryEmail'}
								onChange={(e) => onChange(e)}
								error={state.emailErr}
							/>
						</div>
						<p style={{ textAlign: 'left', fontWeight: '600' }}>
							<span
								className="click-here"
								onClick={() => setState((prevState) => ({ ...prevState, loanStep: true }))}
							>
								Click here&nbsp;
						</span>
						if you do not know this email:
					</p>

						{state.clickHere && (
							<>
								<p style={{ textAlign: 'left', fontWeight: '600' }}>Please answer one of the following:</p>

								<div className="row">
									<div className="col">
										<Input
											label={
												<>
													{' '}
													<input
														type="radio"
														name="choice"
														id="loan"
														value="loan"
														onChange={(e) => {
															let val = e.target.checked ? true : false;
															setState((prevState) => ({
																...prevState,
																loanChecked: val,
															}));
														}}
													/>{' '}
												&nbsp; Loan ID
											</>
											}
											disabled={
												document.getElementById('loan') && !document.getElementById('loan').checked
											}
											defaultValue={state.loanID}
											onChange={(e) => {
												let val = e.target.value;
												setState((prevState) => ({
													...prevState,
													loanID: val,
												}));
											}}
										/>
									</div>
									<div className="col">
										<Input
											label={
												<>
													{' '}
													<input
														type="radio"
														name="choice"
														id="reg"
														value="reg"
														onChange={(e) => {
															let val = e.target.checked ? true : false;
															setState((prevState) => ({
																...prevState,
																regChecked: val,
															}));
														}}
													/>{' '}
												&nbsp; Company Registration
											</>
											}
											disabled={
												document.getElementById('reg') && !document.getElementById('reg').checked
											}
											defaultValue={state.companyReg}
											onChange={(e) => {
												let val = e.target.value;
												setState((prevState) => ({
													...prevState,
													companyReg: val,
												}));
											}}
										/>
									</div>
								</div>
							</>
						)}

						<div style={{ textAlign: 'right' }}>
							<div
								className={`btn-main ${state.emailErr !== '' ? 'disabledDiv' : ''}`}
								onClick={state.emailErr !== '' ? () => { } : () => checkEmail()}
							>
								<span>Submit</span>
							</div>
						</div>
					</>
				)}
		</div>
	);
};
const Login = (props) => {
	const { history, dispatch } = props;
	const [state, setState] = useState({
		captcha: false,
		otpCheck: false,
		siteKey: '',
		username: '',
		showPass: false,
		showPassMob: false,
		isPhoneNumber:false,
		phoneNumber:''
	});
	const { captcha, siteKey, otpCheck } = state;

	let userName = '',
		password = '';
	const loginUser = (token = '', type) => {
		// if(state.username === 'chris.cullen@werarephlo.com') return
		if (type === 'desktop') {
			userName = document.getElementById('username').value;
			password = document.getElementById('password').value;
		}
		if (type === 'mobile') {
			userName = document.getElementById('usernameMob').value;
			password = document.getElementById('passwordMob').value;
		}
		if (userName === '' || password === '') {
			alert('Please Fill All Details');
		}
		dispatch(
			postRequest(
				'api/Customer/Login',
				{
					userName: userName,
					password: password,
					reCaptchaToken: token,
					lenderId:1
				},
				loader,
				successHandler,
				errorHandler
			)
		);
	};
	const loginUserOTP = (type) => {
		let otpVal = document.getElementById(type === 'desktop' ? 'otp' : 'otpMob').value;
		if (otpVal === '') {
			Toast.error('OTP is Required');
		} else {
			dispatch(postRequest(
				'/api/Customer/login/OTP',
				{
					"username": state.username,
					"code": otpVal,
					lenderId: 1
				},
				loader,
				successHandler,
				errorHandler
			));
		}
	}
	const verifyOTP = (append = '') => {
        let otp = ''
        for (let index = 1; index < 5; index++) {
            otp += document.getElementById(`digit-${index}${append}`).value
        }
        if (otp.length === 4) {
            //verify
            dispatch(postRequest('/api/Customer/login/OTP',
                {
                    username: state.username,
					code: otp,
					lenderId: 1,
					isBroker:false
                },
                loader,
                loginHandler,
                errorHandler
            ))
        } else {
            Toast.error('Please enter a valid 4-digit OTP')
        }
    }
	const handleChange = (target) => {
		let key = target.attributes.getNamedItem('dataname').value;
		setState(prevState => ({...prevState,
			[key]:target.value
		}))
	}
	const loader = (check) => {
		dispatch(showHideLoader(check));
	};
	const loginHandler = (res) => {
		const { refreshToken } = res.data;
		const { authToken } = res.data.token;
		// setAuthToken(authToken);
		localStorage.setItem('jwt_token', authToken);
		localStorage.setItem('refresh_token', refreshToken);
		const decoded = jwt_decode(authToken);
		dispatch(setCurrentUser(decoded, refreshToken, authToken));
		initSignalRConnectionAndHandlers();
		history.push('/');
		// console.log(res.data, decoded)
	}
	const successHandler = (res) => {
		if(res.data.phoneNumber && !res.data.skipOTP ){
			setState(prevState => ({
				...prevState,
				isPhoneNumber: true,
				phoneNumber:res.data.phoneNumber
			}))
		}else{
			loginHandler(res)
		}
	};
	const errorHandler = (err) => {
		let captcha = false;
		let siteKey = '';
		let otp = false;
		if (err && err.response && err.response.data) {
			if(err.response.data.statusCode === 417){
				document.getElementById('digit-1').focus()
				for (let index = 1; index < 5; index++) {
					document.getElementById(`digit-${index}`).value = ''
				}
			}
			if (err.response.data.statusCode === 423) {
				otp = true;
			}
			else {
				const { attemptsInfo } = err.response.data;
				if (attemptsInfo && attemptsInfo.applyCaptcha && attemptsInfo.applyCaptcha === true) {
					siteKey = attemptsInfo.siteKey;
					captcha = true;
				}
			}
		}
		setState(prevState => ({
			...prevState,
			captcha,
			siteKey,
			otpCheck: otp === false ? prevState.otpCheck : otp,
			isPhoneNumber: otp === false ? prevState.isPhoneNumber : otp
		}));
		// console.log(err)
		// Toast.error("Invalid username or password. Please try again");
		error400(err);
	};

	const error400 = (err) => {
		if (err.response && err.response.data.errors && err.response.data.errors.length > 0) {
			if (typeof err.response.data.errors[0] === 'object') {
				Toast.error(err.response.data.errors[0].description, {}, 4);
			} else {
				Toast.error(err.response.data.errors[0], {}, 4);
			}
		} else if (err.response && !Array.isArray(err.response.data.errors) && err.response.data.errors) {
			Object.keys(err && err.response.data.errors).map((item, i) => {
				return Toast.error(
					err.response.data.errors[item].length && err > 0
						? err.response.data.errors[item]
						: err.response.data.errors[item],
					{},
					1
				);
			});
		} else if (err.response && err.response.data.message) {
			Toast.error(err.response.data.message, {}, 4);
		} else {
			Toast.error('Something went wrong. Please try again');
		}
	};
	const modal = (classname, size, caption, content) => {
		let data = {
			showModal: true,
			modalContent: content,
			className: classname,
			modalSize: size,
			caption: caption,
		};
		dispatch(showHideModal(data));
	};

	const modalContent = () => {
		return <ForgotPassword error400={error400} dispatch={dispatch} />;
	};

	return (
		<div>
			{state.otpCheck === true ? <OTPScreen loginUserOTP={loginUserOTP} /> :state.isPhoneNumber===true?<OTPScreenNew verifyOTP={verifyOTP} phoneNumber={state.phoneNumber}/>: <><section>
				<div className="main-wrapper section" id="main-wrapper">
					<div className="dashboard-wrap section desktop">
						<div className="dashboard-wrap section ptb-5" id="dash">
							<div className="container" id="main">
								<div
									className="row loginPanel"
									style={{
										display: 'block',
										marginLeft: 'auto',
										marginRight: 'auto',
									}}
									id="panel-id"
								>
									<h3 style={{ marginTop: '20px', fontSize: '36px' }} id="h2-id">
										Welcome to the Cubefunder Customer Portal{' '}
									</h3>
									<h4
										style={{
											marginTop: '8px',
											fontSize: '20px',
											marginBottom: '20px',
										}}
										id="h4-id"
									>
										Login below to see your loan details and make payments
									</h4>
									<div
										style={{
											width: '80%',
											marginLeft: '10%',
											marginTop: '10%',
										}}
										id="heading-id"
									>
										<div className="form-group" id="form-id">
											{/* <label>Username</label>
                      <input */}
											<Input
												label="Username"
												type="text"
												className="form-control"
												defaultValue=""
												dataname={'username'}
												onChange={(e)=>handleChange(e.target)}
												id={'username'}
											/>
										</div>
										<div className="form-group" id="form-id2">
											{/* <label>Password</label>
                      <input */}
											<Input
												label="Password"
												type={state.showPass ? 'text' : 'password'}
												className="form-control"
												id={'password'}
												defaultValue=""
												loginStyle={true}
												icon={!state.showPass ? dontShowPass : showPass}
												parentclassname={'positionRelative'}
												imagename={state.showPass ? 'fa fa-eye' : 'fa fa-eye-slash'}
												iconClassName={'passwordIconInput'}
												iconClick={() => {
													state.showPass
														? setState((prevState) => ({
															...prevState,
															showPass: false,
														}))
														: setState((prevState) => ({
															...prevState,
															showPass: true,
														}));
												}}
											/>
										</div>
										<div className="form-group" style={{ textAlign: 'right' }} id="form-3-id">
											<span
												style={{
													color: ' #FD6244',
													cursor: 'pointer',
													fontWeight: '500',
												}}
												onClick={() =>
													modal(
														'modal-dialog',
														'lg',
														'Get your username and password',
														modalContent('forgot')
													)
												}
											>
												Click here if you do not know your username or password.
											</span>
										</div>

										<div style={{ textAlign: 'right' }} id="button-id">
											<button
												className="btn-main black"
												style={{ marginRight: '5px' }}
												onClick={() =>
													modal(
														'modal-dialog',
														'lg',
														'Create Account',
														modalContent('create')
													)
												}
											>
												Create Account
											</button>
											{captcha && captcha === true ? (
												<GoogleReCaptchaProvider reCaptchaKey={siteKey ? siteKey : ''}>
													<ReCaptcha loginUser={() => {
														// if(state.username!=='chris.cullen@werarephlo.com') loginUser('', 'desktop')
															loginUser('', 'desktop')
														}} />
												</GoogleReCaptchaProvider>
											) : (
													<div className="btn-main" onClick={() => {
														// if(state.username!=='chris.cullen@werarephlo.com') loginUser('', 'desktop')
															loginUser('', 'desktop')
														}}>
														<span>Login</span>
													</div>
												)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
				<section>
					<div className="main-wrapper section">
						<div className="dashboard-wrap section mobile">
							<div className="container">
								<div
									className="row loginPanelMobile"
									style={{
										marginTop: '-40px',
										display: 'block',
										marginLeft: 'auto',
										marginRight: 'auto',
									}}
								>
									<h3 style={{ marginTop: '3%', fontSize: '20px' }}>
										Welcome to the Cubefunder Customer Portal{' '}
									</h3>
									<h4 style={{ marginTop: '8px', fontSize: '15px' }}>
										Login below to see your loan details and make payments
								</h4>
									<div>
										<div className="form-group" style={{ marginTop: '0px' }}>
											{/* <label>Username</label>
                    <input */}
											<Input
												label="Username"
												type="text"
												className="form-control"
												defaultValue=""
												dataname={'username'}
												onChange={(e)=>handleChange(e.target)}
												id={'usernameMob'}
											/>
										</div>
										<div className="form-group">
										<Input
											label="Password"
											type={state.showPassMob ? 'text' : 'password'}
											className="form-control "
											id={'passwordMob'}
											parentclassname={'positionRelative'}
											defaultValue=""
											loginStyle={true}
											icon={state.showPassMob ? dontShowPass : showPass}
											imagename={state.showPassMob ? 'fa fa-eye' : 'fa fa-eye-slash'}
											iconClassName={'passwordIconInput passwordIcon'}
											iconClick={() => {
												state.showPassMob
													? setState((prevState) => ({
															...prevState,
															showPassMob: false,
														}))
														: setState((prevState) => ({
															...prevState,
															showPassMob: true,
														}));
												}}
											/>
										</div>
										<div className="form-group" style={{ textAlign: 'center' }}>
											<span
												style={{
													color: ' #FD6244',
													cursor: 'pointer',
													fontWeight: '500',
												}}
												onClick={() =>
													modal(
														'modal-dialog',
														'lg',
														'Get your username and password',
														modalContent()
													)
												}
											>
												Click here if you do not know your username or password.
										</span>
										</div>
										<div style={{ textAlign: 'center' }}>
											{captcha && captcha === true ? (
												<GoogleReCaptchaProvider reCaptchaKey={siteKey ? siteKey : ''}>
													<ReCaptcha loginUser={() => { 
														// if(state.username!=='chris.cullen@werarephlo.com') loginUser('', 'mobile')}
														loginUser('', 'mobile')
													}} />
												</GoogleReCaptchaProvider>
											) : (
													<div className="btn-main" onClick={() => {
														// if(state.username!=='chris.cullen@werarephlo.com') loginUser('', 'mobile')
															loginUser('', 'mobile')
														}}>
														<span>Login</span>
													</div>
												)}
										</div>
										<button
											className="btn-main black"
											style={{ marginTop: '5px' }}
											onClick={() =>
												modal('modal-dialog', 'lg', 'Create Account', modalContent('create'))
											}
										>
											Create Account
									</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section></>}
                {/* <a href = "https://www.greatbritishbusinessshow.co.uk/exhibitors/cubefunder" target="_blank"> <img src={ footer_Banner } className="footer_img_Area"/></a>  */}
		</div>
	);
};
export default connect()(withRouter(Login));
